import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import { createRoute } from 'lib/util';

const CostCenterActionsEdit = ({ costCenter, company, subcompany, t, handleClick = () => {} }) => (
  <Form.Link
    className={'btn btn-outline-primary btn-sm mx-1'}
    to={createRoute(company.id, subcompany.id, `cost_centers/${costCenter.id}/edit`)}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(CostCenterActionsEdit);



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/components/list/actions/CostCentersActionsEdit.js